var _path, _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 40 48",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.4 0 8.4 14.553h-16.8z",
    fill: "#ffab00",
    transform: "matrix(-1 0 0 -1 28.792 48)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    fill: "#ffab00",
    r: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  }, /*#__PURE__*/React.createElement("path", {
    d: "m921.186 496.9v11.9h-15.557v-11.9",
    transform: "translate(-893.011 -478.841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m900.837 495.976 11-11 11 11",
    transform: "translate(-891.44 -474.934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.954 21.043h4.885v8.915h-4.885z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0296982a2e30ea4436889631d363be3d.svg";
export { ForwardRef as ReactComponent };